import {
  NotificationSettings,
  NotificationSettingsClient,
  INotificationSettings,
} from "../../../api/api";
import { AsyncOperationBuilder } from "../../../utilities/api-helper";
import { notificationSettingsClient } from "../api-clients";
import {
  getNotificationSettingsAction,
  saveLimitSettingAction,
  saveEmailSettingAction,
  saveWebSettingAction
} from "./actions";

export async function getSettings() {
  return AsyncOperationBuilder(
    getNotificationSettingsAction,
    (apiClient) => (apiClient as NotificationSettingsClient).getUserSettings(),
    undefined,
    notificationSettingsClient
  );
}

export async function saveLimitSettings(iSettingsUpdate: INotificationSettings) {
  let settingsUpdate: NotificationSettings = new NotificationSettings();
  settingsUpdate.init(iSettingsUpdate);
  return AsyncOperationBuilder(
    saveLimitSettingAction,
    (apiClient) =>
      (apiClient as NotificationSettingsClient).addOrUpdateLimit(settingsUpdate),
    settingsUpdate,
    notificationSettingsClient
  );
}

export async function saveEmailSettings(iSettingsUpdate: INotificationSettings) {
  let settingsUpdate: NotificationSettings = new NotificationSettings();
  settingsUpdate.init(iSettingsUpdate);
  return AsyncOperationBuilder(
    saveEmailSettingAction,
    (apiClient) =>
      (apiClient as NotificationSettingsClient).addOrUpdateEmailSetting(settingsUpdate),
    settingsUpdate,
    notificationSettingsClient
  );
}

export async function saveWebSettings(iSettingsUpdate: INotificationSettings) {
  let settingsUpdate: NotificationSettings = new NotificationSettings();
  settingsUpdate.init(iSettingsUpdate);
  return AsyncOperationBuilder(
    saveWebSettingAction,
    (apiClient) =>
      (apiClient as NotificationSettingsClient).addOrUpdateShowWebNotificationSetting(settingsUpdate),
    settingsUpdate,
    notificationSettingsClient
  );
}